import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "courses_admin_token";
const USERNAME_KEY = "courses_admin_username";
const ROLE_KEY = "courses_admin_role";
const REMEMBER_KEY = "courses_admin_remember";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUsername() {
  return localStorage.getItem(USERNAME_KEY);
}

export function getRole() {
  return localStorage.getItem(ROLE_KEY);
}

export function setSession(token, username, role = "admin", remember = true) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USERNAME_KEY, username);
  localStorage.setItem(ROLE_KEY, role);
  localStorage.setItem(REMEMBER_KEY, remember ? "1" : "0");
}

// ¿El usuario pidió mantener la sesión iniciada? Se usa para llevarle directo
// a su panel cuando vuelve a abrir la app desde el móvil.
export function rememberSession() {
  return localStorage.getItem(REMEMBER_KEY) !== "0";
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USERNAME_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(REMEMBER_KEY);
}

export function isAuthenticated() {
  return !!getToken();
}

export function isAdmin() {
  return isAuthenticated() && getRole() === "admin";
}

export function isInstructor() {
  return isAuthenticated() && getRole() === "instructor";
}

// Axios client with Bearer token automatically attached.
export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      const role = getRole();
      clearSession();
      const path = window.location.pathname;
      if (path.startsWith("/admin")) {
        window.location.href = "/admin/login";
      } else if (path.startsWith("/instructor")) {
        window.location.href = "/instructor/login";
      }
    }
    return Promise.reject(err);
  }
);
